/**
 * Format a "heard" mark's timestamp as mm:ss into the call (when the call's start time
 * is known) else a wall-clock time. Returns null when there is no timestamp. Shared by
 * the script step and the field board so both render heard times identically.
 */
export function heardTimestamp(at: number | undefined, callStartMs?: number): string | null {
  if (at == null) return null;
  if (callStartMs) {
    const s = Math.max(0, Math.floor((at - callStartMs) / 1000));
    return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;
  }
  return new Date(at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}
